import { Outlet, Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import Nav from "../components/Nav";
import '../App.css';


function MainLayout() {
  const { strings } = useLanguage();
  const currentYear = new Date().getFullYear();
  return (
    <div className="main">
      <Nav />
      <Outlet />
      <footer className="site-footer">
        <p>&copy; {currentYear} {strings.copyright}</p>
        <Link to="/terms-of-service" className="site-footer">{strings.terms_of_service.title}</Link>
        <Link to="/privacy-policy" className="site-footer">{strings.privacy_policy.title}</Link>
      </footer>
    </div>
  );
}
export default MainLayout;